export default __webpack_public_path__ + "static/media/plain-sticker-C.0020a842.png";